/**
 * ! @description: This is the main component for the category page ( origin of all the sub components )
 */

// Dependencies
import React, { Fragment } from "react";
import { NavLink, Outlet, useLocation  } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

// CSS
import "./../../../css/categorytab.css";

function CategoryTab() {
  const location = useLocation();
  return (
    <Fragment>
      <nav className="navbar navbar-expand-lg navbar-light m-2 displayPro">
        <ul className="navbar-nav me-auto mb-lg-0 category-underline">
          <li className="nav-item">
            <NavLink
              to="teachers"
              activeclassname="active"
              className={`subNav-color ${location.pathname === "/category" ? 'category-active' : ''}`}
              // style={{}}
              // exact 
              // style={window.location.pathname === "/category" ? style : {}} 
            >
              Teachers
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="students"
              activeclassname="active"
              className="subNav-color"
            >
              Students
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="unmapped"
              activeclassname="active"
              className="subNav-color"
            >
              Unmapped
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="mapped"
              activeclassname="active"
              className="subNav-color"
            >
              Mapped
            </NavLink>
          </li>

          {/* <li className="nav-item">
            <NavLink
              to="training/teachers"
              activeclassname="active"
              className="subNav-color"
            >
              Training
            </NavLink>
          </li> */}
        </ul>

        <div id="option-button">
          <Dropdown>
            <Dropdown.Toggle variant="primary" id="dropdown-basic">
              Waitlists
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>
                <NavLink
                  to="create/teacher"
                  activeclassname="active"
                  className="subNav-color"
                >
                  Create Teacher
                </NavLink>
              </Dropdown.Item>

              <Dropdown.Item>
                <NavLink
                  to="create/student"
                  activeclassname="active"
                  className="subNav-color"
                >
                  Create Student
                </NavLink>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </nav>
      <Outlet />
    </Fragment>
  );
}

export default CategoryTab;
